import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { AgenciesService } from 'app/services/agencies/agencies.service';
import { Location } from '@angular/common';
import { PiecesService } from 'app/services/pieces/pieces.service';
import Swal from 'sweetalert2';
import { SousBienService } from 'app/services/sousBiens/sous-bien.service';

@Component({
  selector: 'app-menu-list',
  templateUrl: './menu-list.component.html',
  styleUrls: ['./menu-list.component.scss']
})
export class MenuListComponent implements OnInit {

  idAgency: any;
  Agency: any;
  projects: any[]; // You may replace `any[]` with the actual type of your projects array
  list: any;
  dataSource = new MatTableDataSource();
  projet: any;

  constructor(private agencieService: AgenciesService, private activatedRoute: ActivatedRoute,private SousBienService: SousBienService,private location: Location,private router: Router) { }

  ngOnInit(): void {
    this.idAgency = this.activatedRoute.snapshot.paramMap.get('id');
    this.agencieService.setIdAgency(this.idAgency);
  
    this.SousBienService.getSousBien(this.idAgency).subscribe((data:any) => {
      this.Agency = data;
      this.projet = this.Agency
  
      // Sort the projets array by createdAt
  
  
      console.log(this.Agency,"here");
    });
  }
  
  // Helper function to parse date string into Date object
  private parseDate(dateString: string): Date {
    const [day, month, year, time] = dateString.split(/\/|\s/);
    const [hour, minute, second] = time.split(':');
  
    // Month is 0-indexed in JavaScript Date, so subtract 1 from the month
    return new Date(Number(year), Number(month) - 1, Number(day), Number(hour), Number(minute), Number(second));
  }
  
  getData() {
    this.agencieService.getAgencieById(this.idAgency).subscribe(data => {
      this.Agency = data;
this.list=this.Agency.projets
    });
  }

  deleteAgenciesProjet(agencieProjet: any) {
    Swal.fire({
      title: "Êtes-vous sûr(e) ?",
      text: "Vous ne pourrez pas revenir en arrière !",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui, supprimez-le."
    }).then((result) => {
      if (result.isConfirmed) {
        this.SousBienService.deleteSousBien(agencieProjet.id).subscribe((response: any) => {
          console.log(this.dataSource.data);
          // this.AgenciesTunis.splice(i,1)
  
          // If you want to show a success message after the deletion, use another Swal.fire here
          Swal.fire({
            title: "Supprimé!",
            text: "Votre agence a été supprimée.",
            icon: "success"
          });
          // Fetch the updated data after deletion
         
        }); setTimeout(() => {
          this.getData()
          }, 500);
        
      }
    });
  }
  navigateBack() {
    this.location.back();
  }

}
